import { render, staticRenderFns } from "./ToolboxTask.vue?vue&type=template&id=49912461"
import script from "./ToolboxTask.vue?vue&type=script&lang=js"
export * from "./ToolboxTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports